export default __webpack_public_path__ + "media/images/mailer/icon_flag-4124d0284c6e173dea37fde4322661e6.png";